import React from "react";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../components/LoadingComponents";
import { IconButton, Box, Paper, Typography, Dialog } from "@mui/material";
import columns from "../../components/CommunicationsComponents/CommunicationsList/CommunicationsColumns";
import MaterialReactTable from "material-react-table";
import {
  useGetServices,
  useDeleteService,
} from "../../components/ServiceComponents";
import { LinkDevice } from "../../components/DeviceComponents";
import { AddLink as LinkIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { useAuthUser } from "react-auth-kit";
import {
  CommunicationsList,
  AddCommunication,
} from "../../components/CommunicationsComponents";
import PageTitle from "../../components/PageTitle/PageTitle";

function Communications(props) {
  const authUser = useAuthUser();

  return (
    <main style={{ width: "100%" }}>
      <PageTitle title="Comunicazioni" />
      {authUser().user.org_id === null ? (
        <CommunicationsList />
      ) : (
        <AddCommunication />
      )}
    </main>
  );
}

export default Communications;
